// getEventTypeLabel — pure mapping of an event type to its display label.
//
// Extracted VERBATIM from `components/AddEventForm.js` (the `getEventTypeLabel`
// helper) as part of the behavior-preserving refactor (issue #240). The source
// uses this label in two places — the modal title ("Add {label}") and the Save
// button ("Add {label}") — so the slimmed container and the extracted
// presentation (task 13.5) consume it. Returns the type-specific label, or the
// generic 'Event' for any unrecognized/missing type (the `default` branch).
//
// In the source this helper closed over the `eventType` prop; here it takes the
// event type as an explicit argument so it stays pure.
//
// Totality mirrors the source EXACTLY: the `switch` cases and the `default`
// 'Event' fallback are copied verbatim; no extra guards added.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Map an event type to its human-readable label.
 *
 * @param {string} eventType - The active event type.
 * @returns {string} The display label ('Flight' | 'Hotel' | 'Car Rental' |
 *                   'Dining Reservation'), or 'Event' for any other value.
 */
export function getEventTypeLabel(eventType) {
  switch (eventType) {
    case 'flight': return 'Flight';
    case 'hotel': return 'Hotel';
    case 'car': return 'Car Rental';
    case 'dining': return 'Dining Reservation';
    default: return 'Event';
  }
}

export default getEventTypeLabel;
